import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

import { setHeadlessUrl } from './setHeadlessUrl';
import type { OpenIn } from '../types';

type EventAction = 'content' | 'exit_link' | 'internal_link' | '';
export const setEventAction = (
  trackingService: TrackingServiceV2,
  displayMode: OpenIn,
  link: string,
): EventAction => {
  const eventActionFallback = link ? 'internal_link' : '';
  let action: EventAction = eventActionFallback;

  if (displayMode === 'chatbot') {
    action = 'content';
  } else if (displayMode === 'new' || displayMode === 'same') {
    action = (trackingService?.evaluateLinkType(link) as EventAction) ?? eventActionFallback;
  } else if (displayMode === 'layer') {
    action = 'content';
  }
  return action;
};

const completeTargetURL = (targetURL: string): string => {
  const { host } = document.location;
  if (targetURL.startsWith('/')) {
    return `${host}${targetURL}`;
  }
  return targetURL;
};

export const setTargetURL = (url: string, openInTabOrLayer: OpenIn) => {
  if (openInTabOrLayer === 'layer') {
    return completeTargetURL(setHeadlessUrl(url));
  }
  if (openInTabOrLayer === 'chatbot') {
    // always empty if chatbot is selected }
    return '';
  }
  return completeTargetURL(url);
};

export const removeSpecialCharacters = (text: string | undefined) => {
  if (!text) {
    return '';
  }
  return text
    .replace(/&#8203;/gi, '')
    .replace(/&zwnj;/gi, '')
    .replace(/&nbsp;/gi, '');
};
